import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";

export const SkeletonSideMenu = () => {
	const menuItems = Array.from({ length: 12 });

	return (
		<Box sx={{ width: 284, bgcolor: "#fff", }}>
			<Stack spacing={1}>
				{menuItems.map((_, index) => (
					<Skeleton
						key={index}
						variant="rectangular"
						height={40}
						sx={{ borderRadius: 1 }}
					/>
				))}
			</Stack>
		</Box>
	);
};
